(function () {
  'use strict';

  /* @ngdoc object
   * @name dutySheet
   * @description
   *
   */
  angular
    .module('acarsMessages', [
      'ui.router'
    ]);
}());
